import { render } from "./GamificationRewardToast.vue?vue&type=template&id=376a07dc&scoped=true&ts=true"
import script from "./GamificationRewardToast.vue?vue&type=script&lang=ts"
export * from "./GamificationRewardToast.vue?vue&type=script&lang=ts"

import "./GamificationRewardToast.vue?vue&type=style&index=0&id=376a07dc&scoped=true&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376a07dc"]])

export default __exports__